<button
    class="ap-button-expand"
    type="button"
    (click)="buttonClicked()"
    [attr.aria-controls]="ariaControls() ? ariaControls() : null"
    [attr.aria-expanded]="expanded()"
    [attr.aria-label]="ariaLabel() ? ariaLabel() : null"
    [attr.aria-labelledby]="ariaLabelledBy() ? ariaLabelledBy() : null"
    data-testid="button"
>
    @if (expanded()) {
        <ap-icon data-testid="icon" name="chevron-up" size="small"></ap-icon>
        <span data-testid="text">{{ closeLabel() || 'expand.button.close' | apContent }}</span>
    } @else {
        <ap-icon data-testid="icon" name="chevron-down" size="small"></ap-icon>
        <span data-testid="text">{{ openLabel() || 'expand.button.open' | apContent }}</span>
    }
</button>
